import Vue from 'vue'
export default {
	name: 'message',
	loading(options) {
		var maxZIndex = this.getMaxZIndex() + 1;

		var Profile = Vue.extend({
			template: '<div class="message-custom" style="z-index:' + maxZIndex + '"><div class="load"><div class="van-loading van-loading--spinner"><span class="van-loading__spinner van-loading__spinner--spinner" style="color: rgb(201, 201, 201);"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span></div><p>' + options + '</p></div></div>',
		})
		// 创建 Profile 实例，并挂载到一个元素上。
		//		new Profile().$mount(id);
		const Instance = new Profile();
		const component = Instance.$mount();
		document.body.appendChild(component.$el);
		const notification = Instance.$children[0];

		return component.$el;
	},
	msg: function(obj,callback) {
		var maxZIndex = this.getMaxZIndex() + 1;

		if(document.getElementsByClassName('msg-custom').length > 0) {
			document.getElementsByClassName('msg-custom')[0].remove();
		}

		var Profile = Vue.extend({
			template: '<div class="msg-custom animate__fadeIn animate__animated'+(obj.className?' '+obj.className:'')+'" style="z-index:' + maxZIndex + '"><p>' + obj.text + '</p></div>',
		})
		const Instance = new Profile();
		const component = Instance.$mount();
		document.body.appendChild(component.$el);
		const notification = Instance.$children[0];

		if(obj.time == 0) {
			callback?callback(component.$el):null;
		} else if(obj.time) {
			setTimeout(function() {
				component.$el.classList.remove("animate__fadeIn");
				component.$el.classList.remove("animate__animated");
				component.$el.classList.add("animate__animated_05");
				component.$el.classList.add("animate__fadeOut");
			}, obj.time);
			setTimeout(function() {
				component.$el.remove();
				callback?callback():null;
			}, obj.time+800);
		} else {
			setTimeout(function() {
				component.$el.classList.remove("animate__fadeIn");
				component.$el.classList.remove("animate__animated");
				component.$el.classList.add("animate__animated_05");
				component.$el.classList.add("animate__fadeOut");
			}, 1200);
			setTimeout(function() {
				component.$el.remove();
				callback?callback():null;
			}, 3000);
		}
	},
	getMaxZIndex: function() {
		var allEle = document.all || document.querySelectorAll("*");
		var zIndex = [];

		for(var i = 0; i < allEle.length; i++) {
			zIndex.push(Number(window.getComputedStyle(allEle[i]).zIndex) || 0); // 简写写法+window.getComputedStyle(__DOM__).zIndex || 012345
		}

		var maxZindex = Math.max.apply(null, zIndex);
		return maxZindex;
	},
	Images: function(urls,callback) {				//预览大图
		var maxZIndex = this.getMaxZIndex() + 1;

		if(document.getElementsByClassName('image-custom').length > 0) {
			document.getElementsByClassName('image-custom')[0].remove();
		}

		var Profile = Vue.extend({
			template: '<div class="layer-image-custom animate__fadeIn animate__animated" style="z-index:' + maxZIndex + '"><p class="image-box"><img src="'+urls+'" ></p><div id="close-image"></div></div>',
		});
		
		const Instance = new Profile();
		const component = Instance.$mount();
		document.body.appendChild(component.$el);
		const notification = Instance.$children[0];

		var closebtn=document.getElementById('close-image');
		closebtn.onclick=function(){
			component.$el.remove();
			callback?callback():null;
		}
	},
}


// WEBPACK FOOTER //
// ./src/assets/js/message.js